var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "q-icon",
    "aria-hidden": "true",
    role: "presentation",
    viewBox: "0 0 24 24",
    "data-v-5ea012e0": "",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "dashboard-outline",
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,88a3,3,0,0,1,3,3v22a3,3,0,0,1-3,3H76a3,3,0,0,1-3-3V91a3,3,0,0,1,3-3h36m0-5H76a8,8,0,0,0-8,8v22a8,8,0,0,0,8,8h36a8,8,0,0,0,8-8V91a8,8,0,0,0-8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,12a3,3,0,0,1,3,3V65a3,3,0,0,1-3,3H76a3,3,0,0,1-3-3V15a3,3,0,0,1,3-3h36m0-5H76a8,8,0,0,0-8,8V65a8,8,0,0,0,8,8h36a8,8,0,0,0,8-8V15a8,8,0,0,0-8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,60a3,3,0,0,1,3,3v50a3,3,0,0,1-3,3H15a3,3,0,0,1-3-3V63a3,3,0,0,1,3-3H51m0-5H15a8,8,0,0,0-8,8v50a8,8,0,0,0,8,8H51a8,8,0,0,0,8-8V63a8,8,0,0,0-8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,12a3,3,0,0,1,3,3V37a3,3,0,0,1-3,3H15a3,3,0,0,1-3-3V15a3,3,0,0,1,3-3H51m0-5H15a8,8,0,0,0-8,8V37a8,8,0,0,0,8,8H51a8,8,0,0,0,8-8V15a8,8,0,0,0-8-8Z"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dashboard-outline",
    fill: "#525957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashh);
export default __webpack_public_path__ + "static/media/dashh.16348b8e63b3cbb507da6ce9676da6d2.svg";
export { ForwardRef as ReactComponent };